import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-hutchpopup',
  templateUrl: './hutchpopup.component.html',
  styleUrls: ['./hutchpopup.component.css']
})
export class HutchpopupComponent implements OnInit {
  // This property will be set via the modal's componentInstance.
  iframeUrl: string | undefined;
  sanitizedUrl: SafeResourceUrl | undefined;

  constructor(
    private apiService: ApiService,
    private activeModal: NgbActiveModal,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    // Use the passed iframeUrl to create a sanitized URL.
    if (this.iframeUrl) {
      
      this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeUrl);
    }
  }

  closeDialog(): void {
    this.activeModal.close();
  }
}
